import constants from "@/assets/constants";
import type { ICountry, IDropDownOption, IMasterDataEntity, IPatientType } from "@/models";
import { createStore } from "./core/utils";
import type { BaseStore } from "./types";

export type TMasterDataState = BaseStore & {
  country: ICountry[];
  nationality: ICountry[];
  organisationId: string;
  clinicId: string;
  patientId: string;
  visitId: string;

  races: IDropDownOption[];
  religions: IDropDownOption[];
  languages: IDropDownOption[];
  nationalities: IDropDownOption[];
  maritalStatuses: IDropDownOption[];
  occupations: IDropDownOption[];
  patientTypes: IPatientType[];
  residentialStatuses: IDropDownOption[];
  countryCodes: IDropDownOption[];
};

const initialStates: TMasterDataState = {
  nationality: constants.MOBILE_COUNTRY_CODE,
  country: [],
  organisationId: "",
  clinicId: "",
  patientId: "",
  visitId: "",

  races: [],
  religions: [],
  languages: [],
  nationalities: [],
  maritalStatuses: [],
  occupations: [],
  patientTypes: [],
  residentialStatuses: [],
  countryCodes: [],
};

type TMasterDataStateActions = {
  setMasterDataAction: (
    value: Array<IMasterDataEntity | ICountry | IDropDownOption | { name: string } | string>,
    key: keyof typeof initialStates,
  ) => void;
  setIdAction: (
    value: string,
    key: "organisationId" | "clinicId" | "patientId" | "visitId",
  ) => void;
  resetAction: () => void;
};

const useMasterDataState = createStore<TMasterDataState & TMasterDataStateActions>(
  (set) => ({
    ...initialStates,
    setMasterDataAction: (value, key) => {
      set({ [key]: value });
    },
    setIdAction: (value, key) => {
      set({ [key]: value });
    },
    resetAction: () =>
      set({
        ...initialStates,
      }),
  }),
  {
    name: "master-storage",
    persist: true,
    version: 1,
  },
);

export const storeMasterDataState = useMasterDataState.getState();

export default useMasterDataState;
